'use client';
import { useState } from 'react';

// Interactive price estimator (element v1.0, 2026-07-14): slider over units
// (m², rooms, points...) → live low-high estimate from the article's own price data.
// v1.1 (2026-07-22): optional factor2 — a named-option multiplier (e.g. urgency:
// רגיל/דחוף/חירום) stacked on top of the base slider estimate. Omitted entirely on
// older/simple calc blocks, in which case this renders EXACTLY as v1.0 did.
export default function CalcWidget({ title, unit, min, max, low, high, note, factor2 }: {
  title?: string; unit: string; min: number; max: number; low: number; high: number; note?: string;
  factor2?: { label: string; options: { label: string; mult: number }[] };
}) {
  const [val, setVal] = useState(Math.round((min + max) / 2));
  const [optIdx, setOptIdx] = useState(0);
  const mult = factor2?.options[optIdx]?.mult ?? 1;
  const fmt = (n: number) => '₪' + Math.round(n).toLocaleString('he-IL');
  return (
    <div className="rounded-2xl p-5 my-7" style={{ background: 'linear-gradient(135deg,#eff6ff,#f0fdfa)', border: '1px solid #bfdbfe' }}>
      <div className="font-bold mb-3 flex items-center gap-2" style={{ color: '#0f172a' }}>
        <span className="text-2xl">🧮</span>{title || 'מחשבון הערכת מחיר'}
      </div>
      <div className="flex items-center gap-3 mb-2">
        <input type="range" min={min} max={max} value={val} onChange={e => setVal(Number(e.target.value))}
          className="flex-1 accent-blue-700" aria-label={unit} />
        <span className="font-black text-lg whitespace-nowrap" style={{ color: '#1d4ed8', minWidth: '5.5rem', textAlign: 'left' }}>{val} {unit}</span>
      </div>
      {factor2 && (
        <div className="flex items-center gap-2 mb-3 flex-wrap">
          <span className="text-xs font-semibold flex-shrink-0" style={{ color: '#64748b' }}>{factor2.label}:</span>
          {factor2.options.map((o, i) => (
            <button key={o.label} onClick={() => setOptIdx(i)} type="button"
              className="text-xs font-bold rounded-full px-3 py-1"
              style={{
                border: `1.5px solid ${i === optIdx ? '#1d4ed8' : '#dbeafe'}`,
                background: i === optIdx ? '#1d4ed8' : '#fff', color: i === optIdx ? '#fff' : '#1d4ed8',
                cursor: 'pointer',
              }}>
              {o.label}
            </button>
          ))}
        </div>
      )}
      <div className="text-center rounded-xl py-3 px-4 bg-white" style={{ border: '1px solid #dbeafe' }}>
        <span className="text-sm" style={{ color: '#64748b' }}>הערכת מחיר: </span>
        <span className="font-black text-xl" style={{ color: '#0f172a' }}>{fmt(val * low * mult)} – {fmt(val * high * mult)}</span>
      </div>
      <div className="text-xs mt-2 text-center" style={{ color: '#64748b' }}>
        {note || 'הערכה ארצית בלבד — קבלו הצעות מדויקות מבעלי מקצוע באזורכם'}
      </div>
    </div>
  );
}
